import React, { useEffect, useState } from 'react';
import '../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CssClass from "../Styles/common.module.css";
import http from "../Common/http-common";
import * as common from "../Common/common";
import * as Comp from "../Common/CommonComponents";
import { useNavigate } from 'react-router-dom';
import { GetPageAuthorityFn } from "../Common/authority";
import { toast } from 'react-toastify';
import { useCookies } from "react-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faBell, faSquarePlus, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';
import CreateHoliday from "../Components/Holiday/InsertHoliday";
import HolidayNotify from "../Components/Holiday/HolidayNotify";
import HolidayUpdate from '../Components/Holiday/HolidayUpdate';
import HolidayDelete from '../Components/Holiday/HolidayRemove';

const PAGE_NAME = "Holiday.js";
const MODULE_ID = "WEB_PUB_001";

const Holiday = (props) => {
  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [allData, setAllData] = useState([]);
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]);
  const [startDateFilter, endDateFilter] = dateRangeFilter;
  const [yearList, setYearList] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [selectedHoliday, setSelectedHoliday] = useState(false);
  const [showCreateHoliday, setShowCreateHoliday] = useState(false);
  const [showHolidayNotify, setShowHolidayNotify] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editData, setEditData] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    HOLIDAY_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
    DAY_OF_WEEK: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
    READALL: "N",
  });

  useEffect(() => {
    let promise = GetPageAuthorityFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Dashboard");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
          READALL: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
        toast.error(error);
        navigate("/Dashboard");
      }
    );
  }, [userId, navigate]);

  //region Holiday Use Effect
  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "useEffect Get Holiday List";
      try {
        setLoading(true);
        setLoadingText("Getting Holiday List, please wait...");
        setAllData([]);

        const listItems = [];
        const currentYear = new Date().getFullYear();
        let yearFilter;
        if (!selectedYear || selectedYear.value == null) {
          yearFilter = currentYear;
        } else {
          yearFilter = selectedYear?.value;
        }

        var newStartDate = "";
        var newEndDate = "";
        if (startDateFilter === null && endDateFilter === null) {
          newStartDate = "";
          newEndDate = "";
        } else if (startDateFilter !== null && endDateFilter === null) {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = "";
        } else {
          newStartDate = common.c_Dis_DateTime(startDateFilter).val;
          newEndDate = common.c_Dis_DateTime(endDateFilter).val;
        }

        http
          .get("api/holiday/GetAllHoliday?_holiday=" + userId +
            "&_yearFilter=" +
            yearFilter +
            "&_startDateFilter=" +
            newStartDate +
            "&_endDateFilter=" +
            newEndDate,
            { timeout: 1000000 })
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                const holidayDate = new Date(data.HOLIDAY_DATE);
                const formattedHolidayDate = holidayDate.toLocaleDateString('en-GB');

                const date = new Date(data.UPDATE_DATETIME);
                const formattedDate =
                  date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
                    hour12: true,
                    hour: '2-digit',
                    minute: '2-digit',
                  }).toUpperCase();

                listItems.push({
                  key: data.HOLIDAY_ID,
                  HOLIDAY_ID: data.HOLIDAY_ID,
                  HOLIDAY_NAME: data.HOLIDAY_NAME,
                  FORMATTED_HOLIDAY_DATE: formattedHolidayDate,
                  HOLIDAY_DATE: data.HOLIDAY_DATE,
                  DAY_OF_WEEK: data.DAY_OF_WEEK,
                  USERNAME: data.USERNAME,
                  UPDATE_DATETIME: formattedDate,
                  UPDATE_ID: data.UPDATE_ID,
                });
              });
            }
          setAllData(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting holiday list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
      } catch (err) {
        toast.error("Error on getting holiday list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, yearList]);
  //endregion

  //#region get year list
  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      try {
        functionName = "use Effect Get Year List";
        setLoading(true);
        setLoadingText("Getting Year List, Please wait....");
    
        http
          .get("api/holiday/GetYearList?_sysUser=" + userId, { timeout: 10000})
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].HOLIDAY_YEAR,
                value: response.data[i].HOLIDAY_YEAR,
                label: response.data[i].HOLIDAY_YEAR,
              });
            }
            setYearList(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting year list. PLease try again. (Send)");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading....");
          });
      } catch (err) {
        toast.error("Error on getting year list. Please try again. (Received)");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);
  //#endregion

  //#region Event Handle
  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const createHolidayModal = () => {
    setShowCreateHoliday(!showCreateHoliday);
  };

  const holidayNotifyModal = () => {
    setShowHolidayNotify(!showHolidayNotify);
  };

  const showUpdateModal = (e, row) => {
    setShowUpdate(!showUpdate);
    setEditData(row);
  };

  const hideUpdateModal = () => {
    setShowUpdate(!showUpdate);
    setEditData(null);
  };

  const showDeleteModal = (row) => {
    setShowDelete(true);
    setEditData(row);
  };

  const hideDeleteModal = () => {
    setShowDelete(false);
    setEditData(null);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    
    if (!_filters['global']) {
      _filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
    }

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Holiday</span>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
            className="table-search-input"
            style={{ height: '40px', fontSize: '0.9rem' }}
          />
        </IconField>
      </div>
    );
  };
  
  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;

    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);

    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };
  //#endregion

  return (
    <>
      <div style={{ margin: "8px 8px 0", padding: "5px 10px" }}>
        <table className="profileTable" style={{  width: '100%', border: '1px solid #ccc', backgroundColor: '#ffffff' }}>
          <tr>
            <td style={{ verticalAlign: "middle", width: "10%" }}>Year</td>
            <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
            <td style={{ verticalAlign: "middle", width: "35%" }}>
              <Comp.Select
                options={yearList}
                closeMenuOnSelect={true}
                isClearable={true}
                hideSelectedOptions={false}
                value={selectedYear}
                onChange={setSelectedYear}
                placeholder={new Date().getFullYear().toString()}
              />
            </td>
            <td style={{ verticalAlign: "middle", width: "10%" }}>Date</td>
            <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
            <td style={{ verticalAlign: "middle", width: "35%" }}>
              <Comp.DateTimePicker 
                id="DATE_RANGE_FILTER"
                selectsRange
                onChange={(dates) => setDateRangeFilter(dates)}
                startDate={startDateFilter}
                endDate={endDateFilter}
              />
            </td>
          </tr>
        </table>
      </div>
      <div className={CssClass.btnWrapperTwo}>
        <Comp.Button id="btnSearch" type="general" style={{width: '140px'}} onClick={onReloadHandler}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          <span>&nbsp; SEARCH</span>
        </Comp.Button>
        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnNotify"
            type="general"
            style={{ width: '140px', backgroundColor: '#0c8a59' }}
            onClick={holidayNotifyModal}
            className={CssClass.registerButton}
          >
            <FontAwesomeIcon icon={faBell} />
            <span>&nbsp; NOTIFY</span>
          </Comp.Button>
        )}
      </div>

      <div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
        <div style={{ width: "100%" }}>
          <DataTable value={allData} dataKey="HOLIDAY_ID" header={renderHeader()} filters={filters} filterDisplay="row" 
            onFilter={(e) => { 
              const newFilters = e.filters; 
              setFilters(newFilters); 
              const globalKeyword = newFilters.global?.value || '';
              const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { HOLIDAY_NAME: newFilters.HOLIDAY_NAME?.value || globalKeyword, 
                DAY_OF_WEEK: newFilters.DAY_OF_WEEK?.value || globalKeyword }})); 
              setAllData(updated);
            }}
            selectionMode="multiple" selection={selectedHoliday} onSelectionChange={(e) => setSelectedHoliday(e.value)}
            loading={loading} globalFilter={globalFilterValue} globalFilterFields={[ 'HOLIDAY_NAME', 'DAY_OF_WEEK' ]} removableSort emptyMessage="No holidays found."
            scrollable showGridlines className="datatable" tableStyle={{ minWidth: '50rem' }}
            rowClassName={(rowData) => {
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const parts = rowData.FORMATTED_HOLIDAY_DATE.split(/[\/\-]/);
              const holidayDate = new Date(parts[2], parts[1] - 1, parts[0]);
              return holidayDate > today ? 'future-row' : '';
            }}
          >
            <Column
              header="Action"
              {...(actionAuthority.WRITE === 'Y' && {
                filter: true,
                filterElement: (
                  <button
                    onClick={createHolidayModal}
                    style={{
                      alignItems: 'center',
                      marginLeft: '30px',
                      marginTop: '3px',
                      marginBottom: '3px',
                      padding: '8px',
                      width: '90px',
                      borderRadius: '5px',
                      color: 'white',
                      backgroundColor: '#1873e1',
                    }}
                  >
                    <FontAwesomeIcon icon={faSquarePlus} />
                    <span>&nbsp; ADD</span>
                  </button>
                ),
                showFilterMatchModes: false,
                showFilterOperator: false,
                showFilterMenu: false,
              })}
              body={(rowData) => (
                <div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Modify">
                      <Comp.Button
                        id="btnEdit"
                        type="general"
                        onClick={(e) => showUpdateModal(e, rowData)}
                        style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </Comp.Button>
                    </span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
                    <span title="Delete">
                      <Comp.Button
                        id="btnDelete"
                        type="delete"
                        onClick={() => showDeleteModal(rowData)}
                        style={{ width: "50px", height: "35px" }}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </Comp.Button>
                    </span>
                  )}
                </div>
              )}
              style={{
                width: '10%'
              }}
            />
            <Column
              header="#"
              body={(rowData, options) => options.rowIndex + 1}
              style={{ width: '2.5rem', height: "40px", textAlign: 'center' }}
            />
            <Column field="FORMATTED_HOLIDAY_DATE" header="Holiday Date" sortable
              sortFunction={(e) => {
                const parseDMY = (dateStr) => {
                  if (!dateStr) return new Date(0);

                  const [datePart, timePart] = dateStr.split(' ');
                  const [day, month, year] = datePart.split('/');

                  let hours = 0, minutes = 0, seconds = 0;

                  if (timePart) {
                    [hours, minutes, seconds] = timePart.split(':').map(Number);
                  }

                  return new Date(
                    Number(year),
                    Number(month) - 1,
                    Number(day),
                    hours,
                    minutes,
                    seconds
                  );
                };

                return [...e.data].sort((a, b) =>
                  (parseDMY(a.FORMATTED_HOLIDAY_DATE) - parseDMY(b.FORMATTED_HOLIDAY_DATE)) * e.order
                );
              }}
            />
            <Column field="DAY_OF_WEEK" header="Day" sortable style={{ width: '13rem' }}
              body={(rowData) => (
                <HighlightCell text={rowData.DAY_OF_WEEK} keyword={rowData.__FILTER_KEYWORD__?.DAY_OF_WEEK || ''} />
              )}
            />
            <Column field="HOLIDAY_NAME" header="Holiday Name" sortable style={{ width: '30rem' }}
              body={(rowData) => (
                <HighlightCell text={rowData.HOLIDAY_NAME} keyword={rowData.__FILTER_KEYWORD__?.HOLIDAY_NAME || ''} />
              )}
            />
          </DataTable>
        </div>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />

      <CreateHoliday
        page={props.page}
        module={MODULE_ID}
        showHide={showCreateHoliday}
        onHide={createHolidayModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <HolidayNotify
        page={props.page}
        module={MODULE_ID}
        showHide={showHolidayNotify}
        onHide={holidayNotifyModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <HolidayUpdate
        page={props.page}
        module={MODULE_ID}
        showHide={showUpdate}
        editData={editData}
        onHide={hideUpdateModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      
      {showDelete && (
        <HolidayDelete
          page={props.page}
          module={MODULE_ID}
          showHide={showDelete}
          editData={editData}
          onHide={hideDeleteModal}
          onReload={onReloadHandler}
          onLoading={onLoadingHandler}
        />
      )}
    </>
  );
};

export default Holiday;
